//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.HoleMachiningBuilder.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
import "../CAM/CAM.HoleDrillingCutParameters.js";
let d=[[[0,"ControlPointOffset",1,0],[1,"CrossOverDistance",0,"CAM.InheritableToolDepBuilder",0],[1,"CutParameters",0,"CAM.HoleDrillingCutParameters",1],[0,"IgnoreToolTip",1,1],[0,"IntersectionStrategy",1,0],[0,"RetractOutputMode",1,0]],[[[],"GetToolDrivePoint",{R_:{toolDrivePoint:''}},0,0],[["toolDrivePoint"],"SetToolDrivePoint",{},1,0]],[]];
SPLM.CAM.HoleDrillingBuilder = class extends SPLM.CAM.HoleMachiningBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.HoleDrillingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.HoleDrillingBuilder.RetractOutputModeType = Object.freeze({
    "ClearanceOnly" : "ClearanceOnly", "ClearanceInitial" : "ClearanceInitial", "Always" : "Always"});

SPLM.CAM.HoleDrillingBuilder.ControlPointOffsetType = Object.freeze({
    "None" : "None", "Feature" : "Feature", "Initial" : "Initial"});

SPLM.CAM.HoleDrillingBuilder.IntersectionStrategyType = Object.freeze({
    "None" : "None", "Part" : "Part", "Ipw" : "Ipw", "IpwAndPart" : "IpwAndPart"});

export default SPLM;